import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorBoundary } from 'shared/components/error-boundary';
import { memo, useCallback, useEffect } from 'react';
import { useParams } from 'react-router';
import { TariffStepper } from './tariff-stepper';
import { Box, Skeleton } from '@mui/material';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { UpgradeConfirmation } from './upgrade';
import { DowngradeConfirmation } from './downgrade';
import { isUpgrade } from './utils';
import { downgradeTariff, loadTariffs } from './redux/actions';
import { useNavigateBack } from 'shared/hooks/router';
export const ConfirmationPage = memo(function ConfirmationPage() {
    const { tariff_id } = useParams();
    const onBack = useNavigateBack();
    const targetTariff = tariff_id;
    const onDowngradeTariff = useAction(downgradeTariff);
    const onLoadTariff = useAction(loadTariffs);
    const { tariffs_loading, tariffs } = useAppSelector((state) => state.tariffs);
    useEffect(() => {
        if (tariffs == null && !tariffs_loading) {
            onLoadTariff();
        }
    }, [tariffs, tariffs_loading]);
    const currentTariff = useAppSelector((state) => state.billing.state.data.tariff.current);
    const downgradeLoading = useAppSelector((state) => state.tariffs.loading);
    const onConfirmDowngrade = useCallback(() => {
        if (targetTariff != null) {
            onDowngradeTariff(targetTariff);
        }
    }, [onDowngradeTariff, targetTariff]);
    const targetTariffDescription = tariffs != null && targetTariff != null
        ? tariffs.find((descr) => descr.id == targetTariff)
        : null;
    return (_jsxs(ErrorBoundary, { children: [_jsx(Box, { p: 2, height: '100%', children: targetTariffDescription != null ? (targetTariff != null &&
                    (isUpgrade(currentTariff, targetTariff, tariffs) ? (_jsx(UpgradeConfirmation, { targetTariffDescription: targetTariffDescription })) : (_jsx(DowngradeConfirmation, { currentTariff: currentTariff, targetTariff: targetTariff, loading: downgradeLoading, onBack: onBack, onConfirm: onConfirmDowngrade })))) : (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 5, width: 600, children: [_jsxs(Box, { width: "100%", mb: 5, children: [_jsx(Box, { mb: 1, children: _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 60 }) }), _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 200 })] }), _jsx(Box, { display: "flex", justifyContent: "center", children: _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 40, width: 400 }) })] })) }), _jsx(Box, { pb: 5, children: _jsx(TariffStepper, { step_id: 1 }) })] }));
});
